import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';

interface CouponImmediateStartConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  mode: 'register' | 'update';
}

const CouponImmediateStartConfirmDialog: React.FC<CouponImmediateStartConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  mode,
}) => {
  const isRegister = mode === 'register';
  
  return (
    <Dialog
      open={open}
      onClose={(_event: React.SyntheticEvent, reason?: string) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onClose();
        }
      }}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          position: 'fixed',
          top: '5%',
          margin: 0,
        }
      }}
    >
      <DialogTitle>
        {isRegister ? '即日開始のクーポンを登録しますか？' : '開始日を本日に変更しますか？'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {isRegister
            ? '開始日が本日に設定されています。'
            : '開始日を未来日から本日に変更しようとしています。'}
          <br/>
          {isRegister ? '登録' : '変更'}後すぐに利用可能になるため、以下の項目は変更できなくなります：
        </DialogContentText>
        <Box component="ul" sx={{ mt: 1, mb: 2, pl: 3 }}>
          <Typography component="li" variant="body2" color="text.secondary">
            クーポンコード
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary">
            割引タイプ
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary">
            割引値
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary">
            開始日
          </Typography>
        </Box>
        <DialogContentText>
          この内容で{isRegister ? '登録' : '更新'}してよろしいですか？
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="inherit"
        >
          戻る
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          autoFocus
        >
          {isRegister ? '登録する' : '更新する'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CouponImmediateStartConfirmDialog;